import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EnvConfig } from './model';
import { AuthConfig } from '@auth0/auth0-angular';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private envConfig: EnvConfig = {
    tierLoginUrl: '',
    clientId: '',
    idpOrganizationId: '',
    redirectPath: '',
    audience: ''
  };

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  isLocal() {
    console.log(window.location.hostname);
    return window.location.hostname.includes(`.local-vodori.com`);
  }

  getConfig(): Observable<EnvConfig> {
    const subdomain: string = window.location.hostname.split('.')[0];
    let domain: string = window.location.hostname.split('.').slice(-2).join('.');

    if (this.isLocal()) {
      domain = 'dev-vodori.com';
    }

    // If we recognize that this is an auth0 redirect (contains organization_name in query params)
    // Then we need to redirect to the correct login page for that organization.
    const queryParams = new URLSearchParams(window.location.search);
    const orgName = queryParams.get('organization_name');

    if (orgName) {
      const currentHost = window.location.hostname;
      const parts = currentHost.split('.');
      if (parts.length < 3) {
        console.error('Unexpected domain structure:', currentHost);
      } else {
        const baseDomain = parts.slice(1).join('.');
        window.location.href = `https://${orgName}.${baseDomain}/login`;
      }

      // return an empty observable since the page will redirect anyway
      return EMPTY;
    } else if (subdomain === 'default') {
      window.location.href = `https://vodori.com`;
      return EMPTY;
    }

    const params: HttpParams = new HttpParams()
      .set('slug', subdomain)
      .set('domain', domain);

    return this.http.get<EnvConfig>(
      `https://platform-api.vodori.${domain}/api/config`,
      { params }
    );
  }

  loadConfig(authConfig: AuthClientConfig): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getConfig().subscribe({
        next: (config: EnvConfig) => {
          this.envConfig = config;

          const newAuthConfig: AuthConfig = this.prepareAuthConfig();
          authConfig.set(newAuthConfig);
          resolve(true);
        },
        error: (error) => {
          console.error('Error loading configuration:', error);
          reject(error);
        }
      });
    });
  }

  prepareAuthConfig(): AuthConfig {
    return {
      domain: this.envConfig.tierLoginUrl,
      clientId: this.envConfig.clientId,
      authorizationParams: {
        organization: this.envConfig.idpOrganizationId,
        prompt: 'select_account',
        audience: this.envConfig.audience,
        redirect_uri: window.location.origin + '/login',
      },
      // CLOUD-7574: Do not use localstorage because it breaks authentication synchronization with the web extension.
      cacheLocation: 'memory',
      useRefreshTokens: true,
      useRefreshTokensFallback: true
    };
  }

}
